module.exports = __webpack_public_path__ + "static/media/img_app.6d48b054.png";